import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { lineDots } from "@/utils/rechartsInteraction";
import { formatNumber } from "@/utils/format";
import type { ChaoAvancoChartPoint } from "./chaoAvancoFinanceiroUtils";

interface Props {
  data: ChaoAvancoChartPoint[];
  height?: number;
}

export function ChaoObraAvancoChart({ data, height = 200 }: Props) {
  const dense = data.length > 12;
  const dotR = dense ? 2.5 : 3.5;
  return (
    <div className="w-full h-full min-h-0" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 4, right: 8, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
          <XAxis
            dataKey="mes"
            tick={{ fontSize: 10, fill: "#94a3b8" }}
            axisLine={false}
            tickLine={false}
            interval={dense ? 2 : 0}
            minTickGap={8}
            dy={4}
          />
          <YAxis
            domain={[0, 100]}
            ticks={[0, 25, 50, 75, 100]}
            tickFormatter={(v: number) => `${formatNumber(v, 0)}%`}
            tick={{ fontSize: 10, fill: "#94a3b8" }}
            axisLine={false}
            tickLine={false}
            width={40}
          />
          <Tooltip
            formatter={(v: unknown, name: unknown) => [
              `${formatNumber(Number(v), 1)}%`,
              name === "fisico" ? "Avanço físico (obra)" : "Avanço financeiro (Gerencial)",
            ]}
            labelFormatter={(label, payload) => {
              const point = payload?.[0]?.payload as ChaoAvancoChartPoint | undefined;
              return point?.periodo ?? String(label);
            }}
            contentStyle={{ fontSize: 12, borderRadius: 8, border: "1px solid #e2e8f0" }}
          />
          <Legend
            iconType="circle"
            iconSize={8}
            wrapperStyle={{ fontSize: 11, paddingTop: 2 }}
            formatter={(value) =>
              value === "fisico" ? "Avanço físico (obra)" : "Avanço financeiro (Gerencial)"
            }
          />
          <Line
            type="monotone"
            dataKey="financeiro"
            name="financeiro"
            stroke="#22c55e"
            strokeWidth={2}
            {...lineDots("#22c55e", { dotR })}
          />
          <Line
            type="monotone"
            dataKey="fisico"
            name="fisico"
            stroke="#f59e0b"
            strokeWidth={2}
            {...lineDots("#f59e0b", { dotR })}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
